import React from 'react';
export function SocialProofSection() {
  const stats = [{
    number: '+200',
    label: 'Coaches Using It'
  }, {
    number: '6',
    label: 'Complete Volumes'
  }, {
    number: '6',
    label: 'Strategic Bonuses'
  }, {
    number: '4.9/5',
    label: 'Average Rating'
  }];
  return <section className="bg-nero-card py-12 border-y border-nero-border/30" data-id="element-246">
      <div className="max-w-6xl mx-auto px-4" data-id="element-247">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-248">
          {stats.map((stat, idx) => <div key={idx} className="flex flex-col items-center justify-center" data-id="element-249">
              <span className="text-soft-gold text-3xl md:text-4xl font-bold font-playfair mb-2" data-id="element-250">
                {stat.number}
              </span>
              <span className="text-[#CCCCCC] text-xs md:text-sm uppercase tracking-wider" data-id="element-251">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}